window.addEventListener('DOMContentLoaded', () => {
    const embeds = document.querySelectorAll('[data-embed]');

    const createEmbedLink = (url) => {
        const youtubeRegex = /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*?[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig;
        const vimeoRegex = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/

        if (url.match(youtubeRegex)) {
            return url.replace(youtubeRegex, 'https://www.youtube.com/embed/$1');
        } else if (url.match(vimeoRegex)) {
            return url.replace(vimeoRegex, 'https://player.vimeo.com/video/$5');
        }
        return false;
    }

    for (const embed of embeds) {
        const src = createEmbedLink(embed.getAttribute('data-embed'));
        if (!src) {
            continue;
        }
        const embedClass = `embed__video`;
        const height = embed.clientWidth / 1.7778;
        embed.innerHTML = `<iframe style="height: ${height}px; width: 100%;" class="${embedClass}" src="${src}" frameborder="0" allow="autoplay; fullscreen; accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen aria-label="Videoinnhold"></iframe>`;
    }
});